import styled from "styled-components";

export const Container = styled.div`
   
   .content{
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 90%;
   }
    .tutorial .number {
        font-size: inherit;
        font-weight: bold;
    }
    .tutorial a {
        display: inline;
        color: inherit;
        font-size: inherit;
    }
    .tutorial img {
        display: block;
        max-width: 100%;
        width: 900px;
        border: 1px solid #58595b;
        padding: 10px;
        border-radius: 5px;
        margin: auto;
    }
    .tutorial p + img {
        margin-top: 10px;
    }
    .tutorial img + p {
        margin-top: 30px;
    }
    p{
        max-width: 900px;
    }
    .bgHeader{
        width: 100%;
        height: 120px;
        background-color: #fbe777;
    }

    .HomeText{
        max-width: 1420px;
        width: 90%;
        margin: auto;
        
        .initialImg{
            margin: auto;
            width: 600px;
            height: auto;
            margin-bottom: 2rem;
        }

        a{
            background-color: #0d5b5b;
            text-transform: uppercase;
            font-weight: bold;
            color: #fbe777;
            display: flex;
            align-items: center;
            font-size: 1.3em;
            justify-content: center;
            width: 350px;
            height: 50px;
            border-radius: 30px;
            padding: 0px 10px;
            margin: auto;
        }

        .bnts{
            display: flex;
            align-items: flex-start;
            gap: 60px;
            justify-content: center;
            margin-top: 3rem;
            text-align: center;

            p{
                margin-bottom: 20px;
            }

            a{
                width: 250px;
                border-radius: 10px;
            }
        }
    }

    @media only screen and (max-width: 1080px) {
        header .headerContent {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: auto;
            gap: 20px;
            .logo{
                width: 150px;
            }

            .icons{
                margin-top: 0px;
                flex-direction: row;
                margin-bottom: 2rem;
            }
        }

        header::before{
            display: none;
        }
    }

    @media only screen and (max-width: 768px) {
        .HomeText .bnts {
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
    }
`;